export const ADD_CARD_TEST_IDS = {
  ZIP_CODE_FIELD: 'add_card_zip_code_field',
};
